import type { CloudVpc } from 'Admin/Clusters/CreateClusterDialog/useVpcs/queries';

import type { RouteServer } from './queries';
import { RoutePickerMode } from './useRouteServer';

const FILTER_AFTER = 6;

export function rgOptions(groups: string[]) {
  return groups.map(group => ({
    value: group,
    label: group,
    key: group,
  }));
}

export function vpcOptions(vpcs: CloudVpc[]) {
  return vpcs.map(vpc => ({
    value: vpc.id,
    label: `${vpc.name || vpc.id} (${vpc.cidr})`,
    key: vpc.id,
  }));
}

/**
 * @param routeServers - list of route servers for that region
 * @param machines - number of machines needed for successful FGW HA deployment
 */
export function routeServerOptions(routeServers: RouteServer[], machines = 0) {
  return routeServers.map(rs => {
    // max machines is a number derived from `routeServer.bgpConnections` and resolved
    // in apollo client side
    const supportedNumberOfMachines = rs.maxMachines ?? 0;

    return { value: rs.name, key: rs.name, label: rs.name, data: rs, disabled: machines > supportedNumberOfMachines };
  });
}

export function isFilterable(xs: unknown[]): boolean {
  return xs.length > FILTER_AFTER;
}

export function routeServerDescription(mode: RoutePickerMode, vWanActive?: boolean): string {
  const routeServerName = vWanActive ? 'Route Service' : 'Route Server';

  const DESCRIPTION = `Azure ${routeServerName} enables NC2 to exchange route information with Azure native virtual networks dynamically.`;

  switch (mode) {
    case RoutePickerMode.EXISTING: {
      return `${DESCRIPTION} Select the ${routeServerName} NC2 should use for this cluster.`;
    }
    case RoutePickerMode.NEW: {
      return `${DESCRIPTION} NC2 will create a new VNet and Route Server for this cluster.`;
    }
    default: {
      return '';
    }
  }
}

// maximum number of bgp peers
// https://learn.microsoft.com/en-us/azure/route-server/overview#route-server-limits
export const AZURE_ROUTE_SERVER_MAX_PEERS = 16;

export function getMaxFgwMachineCount(bgpConnectionsCount = 0) {
  return Math.floor((AZURE_ROUTE_SERVER_MAX_PEERS - bgpConnectionsCount) / 2);
}
